export default __webpack_public_path__ + "edeeab64ae40810d33d64ff4fc29911f.svg";